export { default } from './HomeBroadband'
export * from './HomeBroadband'
